<mat-card class="linq-card--legacy">
	<div class="table-header mat-elevation-z8">
		<sl-title-buttons [buttons]="titleButtons" class="pull-right title-button"></sl-title-buttons>
	</div>
	<sl-table [config]="tableConfig" [data]="cashAccounts"></sl-table>
</mat-card>

<ng-template #tblSelectAccountDisplay let-row="row">
	<div class="table-select-account-display">
		<span>{{row.AccountNumber}}</span>
		<mat-icon class="warn-color" matTooltip="{{row.Warning}}" *ngIf="row.Warning">warning</mat-icon>
	</div>
</ng-template>
